var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelfRegAccountExistsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 101.25,
    viewBox: "0 0 180 101.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Account_exists_icon",
    "data-name": "Account exists icon",
    transform: "translate(90 50.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42079",
    "data-name": "Group 42079",
    transform: "translate(-90 -50.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42066",
    "data-name": "Group 42066",
    transform: "translate(102.461)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123775",
    "data-name": "Path 123775",
    d: "M148.743,38l-2.8.257a36.673,36.673,0,0,0,.993,5.756l2.725-.7A33.923,33.923,0,0,1,148.743,38Z",
    transform: "translate(-145.788 -11.281)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123776",
    "data-name": "Path 123776",
    d: "M156.328,59.589l-2.37,1.515a37.259,37.259,0,0,0,3.524,4.658l2.1-1.868A34.415,34.415,0,0,1,156.328,59.589Z",
    transform: "translate(-148.167 -17.69)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123777",
    "data-name": "Path 123777",
    d: "M161.85,70.506a37.116,37.116,0,0,0,4.512,3.7L167.97,71.9a34.345,34.345,0,0,1-4.17-3.425Z",
    transform: "translate(-150.51 -20.33)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123778",
    "data-name": "Path 123778",
    d: "M171.765,77.847a36.943,36.943,0,0,0,5.254,2.542l1.02-2.62a34.255,34.255,0,0,1-4.854-2.348Z",
    transform: "translate(-153.454 -22.391)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123779",
    "data-name": "Path 123779",
    d: "M148.535,31.275a34.393,34.393,0,0,1,.357-4.941l-2.784-.4a37.28,37.28,0,0,0-.386,5.346l0,.48,2.813-.037Z",
    transform: "translate(-145.722 -7.698)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123780",
    "data-name": "Path 123780",
    d: "M156.534,4.657l-2.287-1.638a37.06,37.06,0,0,0-3.015,5l2.514,1.258A34.33,34.33,0,0,1,156.534,4.657Z",
    transform: "translate(-147.358 -0.896)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123781",
    "data-name": "Path 123781",
    d: "M151.391,14.97l-2.608-1.055a36.844,36.844,0,0,0-1.751,5.574l2.743.626A33.8,33.8,0,0,1,151.391,14.97Z",
    transform: "translate(-146.111 -4.131)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123782",
    "data-name": "Path 123782",
    d: "M161.786,0h-3.407l1.933,1.629C160.783,1.07,161.278.529,161.786,0Z",
    transform: "translate(-149.48)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123783",
    "data-name": "Path 123783",
    d: "M233.845,0h-.612c.1.1.2.2.292.3Z",
    transform: "translate(-171.702)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123784",
    "data-name": "Path 123784",
    d: "M151.2,49.234l-2.66.912a36.823,36.823,0,0,0,2.331,5.36l2.481-1.324A34.049,34.049,0,0,1,151.2,49.234Z",
    transform: "translate(-146.56 -14.616)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123785",
    "data-name": "Path 123785",
    d: "M183.17,82.7a36.6,36.6,0,0,0,5.711,1.225l.368-2.788a33.834,33.834,0,0,1-5.272-1.131Z",
    transform: "translate(-156.839 -23.753)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123786",
    "data-name": "Path 123786",
    d: "M246.81,16.893a36.712,36.712,0,0,0-2.04-5.477L242.221,12.6A34.061,34.061,0,0,1,244.1,17.66Z",
    transform: "translate(-174.37 -3.389)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123787",
    "data-name": "Path 123787",
    d: "M238.358.838l-2.2,1.754a34.358,34.358,0,0,1,3.024,4.471l2.448-1.387A37.209,37.209,0,0,0,238.358.838Z",
    transform: "translate(-172.57 -0.249)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123788",
    "data-name": "Path 123788",
    d: "M245.785,40.845l2.758.555a37.008,37.008,0,0,0,.693-5.8l-2.81-.111A34.141,34.141,0,0,1,245.785,40.845Z",
    transform: "translate(-175.428 -10.536)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123789",
    "data-name": "Path 123789",
    d: "M245.8,23.8a34.146,34.146,0,0,1,.631,5.356l2.81-.107a36.9,36.9,0,0,0-.684-5.8Z",
    transform: "translate(-175.433 -6.901)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123790",
    "data-name": "Path 123790",
    d: "M243.341,50a3.386,3.386,0,0,1,2.367,1.659,36.743,36.743,0,0,0,1.42-4.051l-2.7-.772C244.119,47.905,243.752,48.962,243.341,50Z",
    transform: "translate(-174.703 -13.905)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123791",
    "data-name": "Path 123791",
    d: "M207.113,80.632l.513,2.765a36.653,36.653,0,0,0,5.644-1.524l-.947-2.647A33.868,33.868,0,0,1,207.113,80.632Z",
    transform: "translate(-163.947 -23.52)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123792",
    "data-name": "Path 123792",
    d: "M230.147,69.183c-.712.657-1.45,1.286-2.211,1.878l1.726,2.22c.966-.752,1.895-1.56,2.786-2.406a5.747,5.747,0,0,1-1.28-.583A2.8,2.8,0,0,1,230.147,69.183Z",
    transform: "translate(-170.129 -20.539)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123793",
    "data-name": "Path 123793",
    d: "M195.578,81.914l-.148,2.808c.644.034,1.3.051,1.967.052a37.6,37.6,0,0,0,3.869-.2l-.292-2.8A35.056,35.056,0,0,1,195.578,81.914Z",
    transform: "translate(-160.479 -24.277)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123794",
    "data-name": "Path 123794",
    d: "M218.085,76.69l1.155,2.564a37.017,37.017,0,0,0,5.119-2.815l-1.546-2.35A34.2,34.2,0,0,1,218.085,76.69Z",
    transform: "translate(-167.205 -21.995)",
    fill: "#cfcfcf"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_123795",
    "data-name": "Path 123795",
    d: "M190.988,42.8l-.433.05a19.5,19.5,0,0,1-2.19.126,19.206,19.206,0,0,1-3.187-.267l-.43-.072L182.019,46.4a23.4,23.4,0,0,1-2.883-1.022l.25-4.642-.38-.215a19.1,19.1,0,0,1-4.262-3.277l-.306-.312-4.418,1.442a23.559,23.559,0,0,1-1.736-2.523l2.929-3.6-.182-.4a18.945,18.945,0,0,1-1.524-5.157l-.063-.432-4.419-1.429c-.011-.3-.018-.609-.018-.916,0-.707.033-1.427.1-2.147l4.487-1.194.086-.428a18.928,18.928,0,0,1,1.8-5.069l.2-.387-2.735-3.755A23.445,23.445,0,0,1,170.811,8.5l4.335,1.673.321-.3A19.105,19.105,0,0,1,179.9,6.832l.39-.194-.006-4.649a23.225,23.225,0,0,1,2.935-.867l2.525,3.905.434-.051a19.493,19.493,0,0,1,2.19-.125,19.237,19.237,0,0,1,3.187.266l.43.072,2.728-3.764A23.192,23.192,0,0,1,197.6,2.447l-.252,4.642.38.215a19.11,19.11,0,0,1,4.264,3.276l.305.313,4.419-1.441a23.482,23.482,0,0,1,1.735,2.523l-2.929,3.6.182.4a18.91,18.91,0,0,1,1.524,5.157l.063.432L211.706,23q.018.456.018.915c0,.707-.032,1.427-.1,2.147l-4.487,1.194-.086.43a18.9,18.9,0,0,1-1.8,5.068l-.2.387,2.737,3.755a23.7,23.7,0,0,1-1.867,2.427l-4.335-1.672-.321.3a19.089,19.089,0,0,1-4.431,3.048l-.391.195.006,4.648a23.168,23.168,0,0,1-2.935.868Zm-2.623-29.026a10.141,10.141,0,1,0,10.141,10.14A10.152,10.152,0,0,0,188.366,13.771Z",
    transform: "translate(-48.986 -0.333)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123796",
    "data-name": "Path 123796",
    d: "M234.8,70.911,233.531,68.3l-.352-.063a9.094,9.094,0,0,1-3.372-1.339l-.3-.2-2.687,1.053a11.853,11.853,0,0,1-1.218-1.327l1.254-2.626-.166-.313a9.092,9.092,0,0,1-1.02-3.37l-.036-.359-2.507-1.449a11.823,11.823,0,0,1,.281-1.83l2.843-.66.142-.323a9.18,9.18,0,0,1,1.939-2.831l.253-.251-.433-2.883a11.733,11.733,0,0,1,1.621-.94l2.285,1.811.342-.094a9.255,9.255,0,0,1,3.417-.267l.35.037,1.993-2.145a11.682,11.682,0,0,1,1.726.666l.011,2.907.291.209a9.228,9.228,0,0,1,2.406,2.553l.188.3,2.917.221a11.66,11.66,0,0,1,.543,1.716l-2.26,1.814.019.361c.009.167.015.335.015.5a9.171,9.171,0,0,1-.527,3.076l-.12.336L245,65a11.776,11.776,0,0,1-.986,1.458l-2.825-.634-.269.24a9.151,9.151,0,0,1-3.175,1.842l-.341.115-.854,2.762a11.924,11.924,0,0,1-1.734.127Zm-.091-16.4a4.873,4.873,0,1,0,4.873,4.873A4.879,4.879,0,0,0,234.708,54.506Z",
    transform: "translate(-66.24 -14.231)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123797",
    "data-name": "Path 123797",
    d: "M19.563,22.517l-.657-3.945-3.622-1.695a.55.55,0,0,1-.02-.986l3.549-1.844.493-3.969a.55.55,0,0,1,.931-.324l2.85,2.805,3.927-.758a.55.55,0,0,1,.6.785l-1.787,3.577,1.935,3.5a.55.55,0,0,1-.563.809l-3.955-.594L20.507,22.8A.549.549,0,0,1,19.563,22.517Z",
    transform: "translate(-4.443 -2.849)",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42067",
    "data-name": "Group 42067",
    transform: "translate(24.36 19.614)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26611",
    "data-name": "Rectangle 26611",
    width: 107.087,
    height: 79.633,
    rx: 2.769,
    transform: "translate(12.096)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26612",
    "data-name": "Rectangle 26612",
    width: 102.257,
    height: 76.041,
    transform: "translate(14.512 2.782)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_26613",
    "data-name": "Rectangle 26613",
    d: "M2.813,0H128.467a2.813,2.813,0,0,1,2.813,2.813V5.1a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2.813A2.813,2.813,0,0,1,2.813,0Z",
    transform: "translate(0 76.539)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26614",
    "data-name": "Rectangle 26614",
    width: 98.227,
    height: 69.864,
    transform: "translate(16.526 4.398)",
    fill: "#00a3e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42068",
    "data-name": "Group 42068",
    transform: "translate(72.605 33.836)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10937",
    "data-name": "Ellipse 10937",
    cx: 17.395,
    cy: 17.395,
    r: 17.395,
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10938",
    "data-name": "Ellipse 10938",
    cx: 7.649,
    cy: 7.649,
    r: 7.649,
    transform: "translate(9.747 4.04)",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123798",
    "data-name": "Path 123798",
    d: "M136.842,83.237a19.076,19.076,0,0,0-28.95,1.01,17.4,17.4,0,0,0,28.95-1.01Z",
    transform: "translate(-104.635 -56.717)",
    fill: "#ff7f32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42078",
    "data-name": "Group 42078",
    transform: "translate(83.6 74.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42070",
    "data-name": "Group 42070",
    transform: "translate(0 4.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42069",
    "data-name": "Group 42069"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_26615",
    "data-name": "Rectangle 26615",
    d: "M1.029,0H11.481A1.318,1.318,0,0,1,12.8,1.318V4.879A4.322,4.322,0,0,1,8.477,9.2H4.6A4.6,4.6,0,0,1,0,4.6V1.029A1.029,1.029,0,0,1,1.029,0Z",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42072",
    "data-name": "Group 42072",
    transform: "translate(2.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42071",
    "data-name": "Group 42071"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123799",
    "data-name": "Path 123799",
    d: "M126.254,113.7a4.135,4.135,0,1,1,4.135-4.136A4.14,4.14,0,0,1,126.254,113.7Zm0-6.95a2.814,2.814,0,1,0,2.814,2.814A2.817,2.817,0,0,0,126.254,106.753Z",
    transform: "translate(-122.119 -105.432)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42077",
    "data-name": "Group 42077",
    transform: "translate(4.731 5.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42074",
    "data-name": "Group 42074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42073",
    "data-name": "Group 42073"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123800",
    "data-name": "Path 123800",
    d: "M128.964,115.11a1.669,1.669,0,1,1-1.669-1.669A1.669,1.669,0,0,1,128.964,115.11Z",
    transform: "translate(-125.626 -113.441)",
    fill: "#008dc2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42076",
    "data-name": "Group 42076",
    transform: "translate(1.308 2.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42075",
    "data-name": "Group 42075"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123801",
    "data-name": "Path 123801",
    d: "M127.847,116.923h0a.362.362,0,0,1,.361.361v2.782a.362.362,0,0,1-.361.361h0a.362.362,0,0,1-.361-.361v-2.782A.362.362,0,0,1,127.847,116.923Z",
    transform: "translate(-127.486 -116.923)",
    fill: "#008dc2"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_123802",
    "data-name": "Path 123802",
    d: "M28.055,104.452c-.558,0-1.118-.018-1.666-.056l.188-2.805a22.935,22.935,0,0,0,5.277-.271l.468,2.772A25.624,25.624,0,0,1,28.055,104.452Zm-4.626-.437a22.3,22.3,0,0,1-5.677-1.9L19,99.6a19.472,19.472,0,0,0,4.961,1.657Zm11.792-.587-.788-2.7c.317-.093.631-.191.945-.3a25.007,25.007,0,0,0,3.958-1.743l1.349,2.468a27.828,27.828,0,0,1-4.4,1.939Q35.754,103.272,35.221,103.427ZM15.153,100.58a20.541,20.541,0,0,1-4.375-4.131l2.209-1.742a17.715,17.715,0,0,0,3.774,3.566ZM43.2,99.61l-1.587-2.322a29.537,29.537,0,0,0,4.127-3.422l1.981,2A32.431,32.431,0,0,1,43.2,99.61ZM9.089,93.949A19.138,19.138,0,0,1,6.929,88.3l.312-.065a11.887,11.887,0,0,1-3.4-2.763c-.25-.295-.489-.6-.711-.918l2.295-1.624c.176.248.364.491.562.724.184.217.38.426.583.625a11.986,11.986,0,0,1,1.38-5.149l2.476,1.332a9.262,9.262,0,0,0-1.051,4.162v.141c0,.139,0,.277.006.416l-1.659.052a8.726,8.726,0,0,0,1.4.795l-.9,2.005,1.469-.3a16.407,16.407,0,0,0,1.846,4.816Zm40.624-.238-2.144-1.821c.68-.8,1.33-1.645,1.933-2.514l2.31,1.6C51.157,91.924,50.451,92.843,49.712,93.712Zm-37.647-4.2a9.283,9.283,0,0,1-.972-.051l.294-2.8a6.17,6.17,0,0,0,1.264.009,5.817,5.817,0,0,0,2.994-1.22l1.737,2.212a8.648,8.648,0,0,1-4.462,1.807C12.637,89.5,12.351,89.51,12.066,89.51Zm7.5-4.426-2.486-1.316a4.263,4.263,0,0,0,.467-1.446,3.209,3.209,0,0,0,.027-.427,4.135,4.135,0,0,0-.616-2.1l2.406-1.458a6.9,6.9,0,0,1,1.022,3.56,6.094,6.094,0,0,1-.05.789A7.038,7.038,0,0,1,19.561,85.084ZM1.623,81.849a19.636,19.636,0,0,1-1.4-5.3C.2,76.367.179,76.183.16,76l2.8-.29c.016.162.036.323.056.484a16.852,16.852,0,0,0,1.192,4.542Zm10.2-3.142-1.78-2.178a6.133,6.133,0,0,1,3.748-1.438l.182,0a5.856,5.856,0,0,1,2.905.795l-1.4,2.439a3,3,0,0,0-1.5-.421h-.094A3.374,3.374,0,0,0,11.824,78.708ZM0,73.057v-.368c0-1.807.12-3.61.235-5.353l2.807.187c-.113,1.7-.229,3.452-.229,5.166v.349Z",
    transform: "translate(0 -19.99)",
    fill: "#cfcfcf"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfRegAccountExistsIcon);
export default __webpack_public_path__ + "static/media/SelfReg-AccountExistsIcon.548655a754579dec29a22405cc00964f.svg";
export { ForwardRef as ReactComponent };